import React from "react";

import copy from "copy-to-clipboard";
import { Typography, IconButton, Box } from "@mui/material";

import Events from "../../../../../Analytics/Events";
import CustomIcon from "../../../../../Components/CustomIcon";
import { useToast } from "../../../../../Hooks/useToast";
import { Tooltip } from "antd";

const TextWithCopy = ({
    text,
    type,
    textVariant = 'fw400s14lh24c3D4B5A',
    textStyle = {},
    iconStyle = {},
    iconButtonStyle = {},
    toolTipPlacement = "top",
    label = null
}) => {

    const { openNotification } = useToast();

    const handleCopy = (event) => {
        event.stopPropagation();
        copy(text);
        openNotification({ text: 'Copied to Clipboard' })
        Events(`Copied ${type}`);
    };

    return (
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            <Typography style={textStyle} variant={textVariant}>
                {label || text}
            </Typography>

            <Tooltip title="Click to copy" placement={toolTipPlacement} popupStyle={{ zIndex: 2000 }}>
                <IconButton
                    disableRipple
                    disableTouchRipple
                    disableFocusRipple
                    sx={{ py: 0, pr: 0, ...iconButtonStyle }}
                    onClick={handleCopy}
                >
                    <CustomIcon name="copy-icon" style={iconStyle} />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default TextWithCopy;
